// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[2]!../node_modules/leaflet/dist/leaflet.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --main-bg-color: #ffffff;
    --secondary-bg-color: #f8fffe;
    --third-bg-color: #f0f9f6;
    --main-text-color: #2d4a3a;
    --main-text-color-highligth: #4a7c59;
    --secondary-color: #7fcc9f;
    --ar-buttons-bg: #88d8a3;
  }

.App {
    text-align: center;
}

::-webkit-scrollbar {
    width: 4px; /* Adjust as needed */
}

::-webkit-scrollbar-thumb {
    background-color: #7fcc9f; /* Adjust as needed */
    border-radius: 6px;
}

::-webkit-scrollbar-track {
    background-color: #f0f9f6; /* Adjust as needed */
}


/* body > #root > div {
    height: 100vh;
} */

.App-link {
    color: #61dafb;
}

@keyframes App-logo-spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
#root {
    height: 100%;
}

/* Loading Screen */
.loading-screen {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: var(--main-bg-color);
}

.loading-content {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.loading-logo {
  height: 80px;
  width: auto;
  object-fit: contain;
}

.loading-content p {
  color: var(--main-text-color);
  font-size: 1.1rem;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;IACI,wBAAwB;IACxB,6BAA6B;IAC7B,yBAAyB;IACzB,0BAA0B;IAC1B,oCAAoC;IACpC,0BAA0B;IAC1B,wBAAwB;EAC1B;;AAEF;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU,EAAE,qBAAqB;AACrC;;AAEA;IACI,yBAAyB,EAAE,qBAAqB;IAChD,kBAAkB;AACtB;;AAEA;IACI,yBAAyB,EAAE,qBAAqB;AACpD;;;AAGA;;GAEG;;AAEH;IACI,cAAc;AAClB;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI,YAAY;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,SAAS;AACX","sourcesContent":["@import 'leaflet/dist/leaflet.css';\r\n\r\n:root {\r\n    --main-bg-color: #ffffff;\r\n    --secondary-bg-color: #f8fffe;\r\n    --third-bg-color: #f0f9f6;\r\n    --main-text-color: #2d4a3a;\r\n    --main-text-color-highligth: #4a7c59;\r\n    --secondary-color: #7fcc9f;\r\n    --ar-buttons-bg: #88d8a3;\r\n  }\r\n\r\n.App {\r\n    text-align: center;\r\n}\r\n\r\n::-webkit-scrollbar {\r\n    width: 4px; /* Adjust as needed */\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n    background-color: #7fcc9f; /* Adjust as needed */\r\n    border-radius: 6px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n    background-color: #f0f9f6; /* Adjust as needed */\r\n}\r\n\r\n\r\n/* body > #root > div {\r\n    height: 100vh;\r\n} */\r\n\r\n.App-link {\r\n    color: #61dafb;\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n    from {\r\n        transform: rotate(0deg);\r\n    }\r\n    to {\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n#root {\r\n    height: 100%;\r\n}\r\n\r\n/* Loading Screen */\r\n.loading-screen {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100vh;\r\n  background: var(--main-bg-color);\r\n}\r\n\r\n.loading-content {\r\n  text-align: center;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 20px;\r\n}\r\n\r\n.loading-logo {\r\n  height: 80px;\r\n  width: auto;\r\n  object-fit: contain;\r\n}\r\n\r\n.loading-content p {\r\n  color: var(--main-text-color);\r\n  font-size: 1.1rem;\r\n  margin: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
